<!-- Sankey Diagramm-->
<div class="px-4 py-4 sm:px-6 select-none">
  <h3 class="text-2xl leading-6  text-gray-900">
    Sankey-Diagramm
  </h3>
</div>

<div class="px-4 pt-1 pb-10 sm:p-6 select-none">
  <!--
    Chart.js sizing box (Bug #234): `w-full` is Tailwind, `w-100` was BOOTSTRAP (`width:100%!important`).
    This chart runs `maintainAspectRatio: false`, so its height comes ENTIRELY from this wrapper's `h-96` —
    dropping the definite height here collapses the sankey diagram to 0.
  -->
  <div class="w-full h-96 flex justify-content-center">
    @if (sankeyStore.errorCode != ErrorCodes.loading && sankeyStore.errorCode != undefined) {
      <analytics-error-message [analysisErrorState]="sankeyStore.errorCode"/>
    }
    @if (sankeyStore.errorCode == ErrorCodes.loading) {
      <div
        class="inline-block align-self-center h-16 w-16 animate-spin rounded-full border-4 border-solid border-current border-r-transparent align-[-0.125em] motion-reduce:animate-[spin_1.5s_linear_infinite]"
        role="status">
      </div>
    }
    <!-- `w-full` (Tailwind), not `w-100` (Bootstrap `!important`) — #234. -->
    <canvas #sankeyChart [ngClass]="{ hidden: sankeyStore.errorCode != undefined }"
            class="inline-flex sm:h-96 w-full"></canvas>
  </div>
</div>

